var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "basic-container",
        [
          _c(
            "avue-crud",
            {
              ref: "crud",
              attrs: { option: _vm.option, data: _vm.list },
              on: {
                "refresh-change": _vm.refreshChange,
                "sortable-change": _vm.sortableChange,
              },
              scopedSlots: _vm._u([
                {
                  key: "mediaName",
                  fn: function (scope) {
                    return [
                      _c("span", { staticStyle: { color: "blue" } }, [
                        _vm._v(_vm._s(scope.row.mediaName)),
                      ]),
                    ]
                  },
                },
                {
                  key: "menu",
                  fn: function ({ row }) {
                    return [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "RECOMMEND_STRATEGY_EDIT",
                              expression: "'RECOMMEND_STRATEGY_EDIT'",
                            },
                          ],
                          attrs: { type: "text", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.handleEdit(row)
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "RECOMMEND_STRATEGY_DEL",
                              expression: "'RECOMMEND_STRATEGY_DEL'",
                            },
                          ],
                          attrs: { type: "text", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.detailDel(row.id)
                            },
                          },
                        },
                        [_vm._v("删除")]
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c("template", { slot: "mySearch" }, [
                _c("div", { staticClass: "search-contain" }, [
                  _c(
                    "div",
                    { staticClass: "search-left" },
                    [
                      _c("el-input", {
                        staticStyle: { "margin-left": "-10px", padding: "0" },
                        attrs: {
                          size: "large",
                          clearable: "",
                          placeholder: "策略ID&名称",
                        },
                        model: {
                          value: _vm.searchParams.search,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchParams, "search", $$v)
                          },
                          expression: "searchParams.search",
                        },
                      }),
                      _c(
                        "el-select",
                        {
                          staticStyle: { "margin-left": "20px" },
                          attrs: {
                            size: "large",
                            clearable: "",
                            placeholder: "生效状态",
                          },
                          model: {
                            value: _vm.searchParams.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchParams, "status", $$v)
                            },
                            expression: "searchParams.status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "生效", value: 1 },
                          }),
                          _c("el-option", {
                            attrs: { label: "失效", value: 0 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "search-right" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "RECOMMEND_STRATEGY_SEARCH",
                              expression: "'RECOMMEND_STRATEGY_SEARCH'",
                            },
                          ],
                          staticStyle: { "margin-left": "10px" },
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.handleSearch },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "RECOMMEND_STRATEGY_ADD",
                              expression: "'RECOMMEND_STRATEGY_ADD'",
                            },
                          ],
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.handleAdd },
                        },
                        [_vm._v("新增")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            2
          ),
          _c("ElementPagination", {
            staticStyle: { "margin-bottom": "20px" },
            attrs: {
              "current-page": _vm.searchParams.current,
              "page-size": _vm.searchParams.size,
              total: _vm.searchParams.total,
              "page-sizes": [10, 20, 30, 40, 50],
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.isEdit ? "编辑策略" : "新增策略",
            "append-to-body": "",
            visible: _vm.addVisible,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addVisible = $event
            },
            closed: _vm.closeAddDialog,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addForm",
              attrs: {
                inline: "",
                model: _vm.addForm,
                rules: _vm.addFormRules,
                "label-width": "130px",
              },
            },
            [
              _c(
                "el-collapse",
                {
                  on: { change: _vm.handleChange },
                  model: {
                    value: _vm.activeNames,
                    callback: function ($$v) {
                      _vm.activeNames = $$v
                    },
                    expression: "activeNames",
                  },
                },
                [
                  _c(
                    "el-collapse-item",
                    { attrs: { name: "1" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c("h3", { staticClass: "add-title" }, [
                          _vm._v("基础配置"),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "add-item" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "name", label: "策略名称：" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "30vw" },
                                model: {
                                  value: _vm.addForm.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.addForm, "name", $$v)
                                  },
                                  expression: "addForm.name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { prop: "descr", label: "策略描述：" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "30vw" },
                                model: {
                                  value: _vm.addForm.descr,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.addForm, "descr", $$v)
                                  },
                                  expression: "addForm.descr",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-collapse-item",
                    { attrs: { name: "2" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c("h3", { staticClass: "add-title" }, [
                          _vm._v("媒资配置"),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "add-item error-update" },
                        [
                          _c("el-form-item", {
                            attrs: {
                              prop: "tacticsMedias",
                              "label-width": "120px",
                              label: "媒资选择：",
                            },
                          }),
                          _c("el-form-item", { staticClass: "media-select" }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "baseline",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: {
                                    width: "120px",
                                    "margin-right": "10px",
                                  },
                                  attrs: {
                                    clearable: "",
                                    size: "small",
                                    placeholder: "媒资名称",
                                  },
                                  model: {
                                    value: _vm.mediaSelectParams.name,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.mediaSelectParams,
                                        "name",
                                        $$v
                                      )
                                    },
                                    expression: "mediaSelectParams.name",
                                  },
                                }),
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      width: "120px",
                                      "margin-right": "10px",
                                    },
                                    attrs: {
                                      clearable: "",
                                      size: "small",
                                      placeholder: "媒资类型",
                                    },
                                    model: {
                                      value: _vm.mediaSelectParams.type,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.mediaSelectParams,
                                          "type",
                                          $$v
                                        )
                                      },
                                      expression: "mediaSelectParams.type",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "电影", value: 1 },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "电视剧", value: 2 },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "动画片", value: 3 },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "短剧", value: 4 },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "电影票", value: 5 },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "团购券", value: 6 },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "其它", value: 0 },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "120px" },
                                    attrs: {
                                      clearable: "",
                                      size: "small",
                                      placeholder: "媒资来源",
                                    },
                                    model: {
                                      value: _vm.mediaSelectParams.source,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.mediaSelectParams,
                                          "source",
                                          $$v
                                        )
                                      },
                                      expression: "mediaSelectParams.source",
                                    },
                                  },
                                  _vm._l(_vm.mediaSourceList, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.name,
                                        value: item.name,
                                      },
                                    })
                                  }),
                                  1
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "30px" },
                                    attrs: { size: "small", type: "primary" },
                                    on: { click: _vm.mediaConfSearch },
                                  },
                                  [_vm._v("搜索")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "10px" },
                                    attrs: { type: "info", size: "small" },
                                    on: { click: _vm.mediaConfReset },
                                  },
                                  [_vm._v("重置")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "10px" },
                                    attrs: { size: "small" },
                                    on: { click: _vm.handleMediaSelect },
                                  },
                                  [_vm._v("媒资选择")]
                                ),
                              ],
                              1
                            ),
                            _vm.addForm.tacticsMedias.length
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "flex-direction": "column",
                                      width: "100%",
                                    },
                                  },
                                  [
                                    _c(
                                      "avue-crud",
                                      {
                                        ref: "crud",
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          option: _vm.dragOption,
                                          data: _vm.addForm.tacticsMedias,
                                        },
                                        on: {
                                          "sortable-change": _vm.sortChange,
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "status",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      class: {
                                                        "gary-text":
                                                          scope.row.valid ===
                                                          false,
                                                        "green-text":
                                                          scope.row.status ===
                                                            1 &&
                                                          scope.row.valid ===
                                                            true,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.status === 1
                                                            ? "上线"
                                                            : "下线"
                                                        ) +
                                                          "\n                      " +
                                                          _vm._s(
                                                            scope.row.valid ===
                                                              false
                                                              ? "(未生效)"
                                                              : ""
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: "name",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#3370ff",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(scope.row.name)
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: "horizontalImg",
                                              fn: function (scope) {
                                                return [
                                                  scope.row.horizontalImg
                                                    ? _c("el-image", {
                                                        attrs: {
                                                          src: scope.row
                                                            .horizontalImg,
                                                          previewSrcList: [
                                                            scope.row
                                                              .horizontalImg,
                                                          ],
                                                          alt: "",
                                                        },
                                                      })
                                                    : scope.row
                                                        .horizontalImgLarge
                                                    ? _c("el-image", {
                                                        attrs: {
                                                          src: scope.row
                                                            .horizontalImgLarge,
                                                          previewSrcList: [
                                                            scope.row
                                                              .horizontalImgLarge,
                                                          ],
                                                          alt: "",
                                                        },
                                                      })
                                                    : scope.row
                                                        .horizontalImgSmall
                                                    ? _c("el-image", {
                                                        attrs: {
                                                          src: scope.row
                                                            .horizontalImgSmall,
                                                          previewSrcList: [
                                                            scope.row
                                                              .horizontalImgSmall,
                                                          ],
                                                          alt: "",
                                                        },
                                                      })
                                                    : _c("span", [
                                                        _vm._v("暂无图片"),
                                                      ]),
                                                ]
                                              },
                                            },
                                            {
                                              key: "showOption",
                                              fn: function ({ row }) {
                                                return [
                                                  !row.mySelect && !row.mySave
                                                    ? _c("div", [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              row.useType === 1
                                                                ? "片花"
                                                                : row.useType ===
                                                                  2
                                                                ? "分集"
                                                                : ""
                                                            )
                                                          ),
                                                        ]),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              row.useType === 1
                                                                ? `(${
                                                                    row.trailer
                                                                      .id
                                                                      ? row
                                                                          .trailer
                                                                          .id
                                                                      : ""
                                                                  })`
                                                                : row.useType ===
                                                                  2
                                                                ? `(${
                                                                    row.episode
                                                                      .id
                                                                      ? row
                                                                          .episode
                                                                          .id
                                                                      : ""
                                                                  })`
                                                                : ""
                                                            )
                                                          ),
                                                        ]),
                                                        (
                                                          row.useType === 1 &&
                                                          row.trailer.id
                                                            ? true
                                                            : row.useType ===
                                                                2 &&
                                                              row.episode.id
                                                        )
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  "text-decoration":
                                                                    "underline",
                                                                  color:
                                                                    "#3370ff",
                                                                  cursor:
                                                                    "pointer",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleMediaSelectPreview(
                                                                        row
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v(" 预览")]
                                                            )
                                                          : _vm._e(),
                                                      ])
                                                    : !row.mySelect &&
                                                      row.mySave
                                                    ? _c("div", [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              row.useType === 1
                                                                ? "片花"
                                                                : row.useType ===
                                                                  2
                                                                ? "分集"
                                                                : ""
                                                            )
                                                          ),
                                                        ]),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              row.useType === 1
                                                                ? `(${
                                                                    row.trailerId
                                                                      ? row.trailerId
                                                                      : ""
                                                                  })`
                                                                : row.useType ===
                                                                  2
                                                                ? `(${
                                                                    row.episodeId
                                                                      ? row.episodeId
                                                                      : ""
                                                                  })`
                                                                : ""
                                                            )
                                                          ),
                                                        ]),
                                                        (
                                                          row.useType === 1 &&
                                                          row.trailerId
                                                            ? true
                                                            : row.useType ===
                                                                2 &&
                                                              row.episodeId
                                                        )
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  "text-decoration":
                                                                    "underline",
                                                                  color:
                                                                    "#3370ff",
                                                                  cursor:
                                                                    "pointer",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleMediaSelectPreview(
                                                                        row
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v(" 预览")]
                                                            )
                                                          : _vm._e(),
                                                      ])
                                                    : row.mySelect &&
                                                      !row.mySave
                                                    ? _c("div", [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              row.useType === 1
                                                                ? "片花"
                                                                : row.useType ===
                                                                  2
                                                                ? "分集"
                                                                : ""
                                                            )
                                                          ),
                                                        ]),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              row.useType === 1
                                                                ? `(${
                                                                    row.firstTrailer
                                                                      ? row
                                                                          .firstTrailer
                                                                          .id
                                                                      : row.trailer
                                                                      ? row
                                                                          .trailer
                                                                          .id
                                                                      : ""
                                                                  })`
                                                                : row.useType ===
                                                                  2
                                                                ? `(${
                                                                    row.firstEpisode
                                                                      ? row
                                                                          .firstEpisode
                                                                          .id
                                                                      : row.episode
                                                                      ? row
                                                                          .episode
                                                                          .id
                                                                      : ""
                                                                  })`
                                                                : ""
                                                            )
                                                          ),
                                                        ]),
                                                        (
                                                          row.useType === 1 &&
                                                          row.firstTrailer
                                                            ? true
                                                            : row.useType ===
                                                                2 &&
                                                              row.firstEpisode
                                                        )
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  "text-decoration":
                                                                    "underline",
                                                                  color:
                                                                    "#3370ff",
                                                                  cursor:
                                                                    "pointer",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleMediaSelectPreview(
                                                                        row
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v(" 预览")]
                                                            )
                                                          : _vm._e(),
                                                      ])
                                                    : row.mySelect && row.mySave
                                                    ? _c("div", [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              row.useType === 1
                                                                ? "片花"
                                                                : row.useType ===
                                                                  2
                                                                ? "分集"
                                                                : ""
                                                            )
                                                          ),
                                                        ]),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              row.useType === 1
                                                                ? `(${
                                                                    row.trailerId
                                                                      ? row.trailerId
                                                                      : ""
                                                                  })`
                                                                : row.useType ===
                                                                  2
                                                                ? `(${
                                                                    row.episodeId
                                                                      ? row.episodeId
                                                                      : ""
                                                                  })`
                                                                : ""
                                                            )
                                                          ),
                                                        ]),
                                                        (
                                                          row.useType === 1 &&
                                                          row.trailerId
                                                            ? true
                                                            : row.useType ===
                                                                2 &&
                                                              row.episodeId
                                                        )
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  "text-decoration":
                                                                    "underline",
                                                                  color:
                                                                    "#3370ff",
                                                                  cursor:
                                                                    "pointer",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleMediaSelectPreview(
                                                                        row
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v(" 预览")]
                                                            )
                                                          : _vm._e(),
                                                      ])
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                            {
                                              key: "sortOption",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "justify-content":
                                                          "space-between",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "text",
                                                            size: "small",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.sortPrev(
                                                                scope.row
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("上移")]
                                                      ),
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "text",
                                                            size: "small",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.sortNext(
                                                                scope.row
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("下移")]
                                                      ),
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "text",
                                                            size: "small",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.sortTop(
                                                                scope.row
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("置顶")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: "menu",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "justify-content":
                                                          "center",
                                                        "align-items": "center",
                                                      },
                                                    },
                                                    [
                                                      false
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(scope)
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "text",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleMediaEdit(
                                                                scope.row
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("编辑")]
                                                      ),
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "text",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleMediaDel(
                                                                scope.row
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("移出")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1563256515
                                        ),
                                      },
                                      [_c("template", { slot: "mySearch" })],
                                      2
                                    ),
                                    _c("ElementPagination", {
                                      staticStyle: { "margin-bottom": "20px" },
                                      attrs: {
                                        "current-page":
                                          _vm.mediaSelectParams.current,
                                        "page-size": _vm.mediaSelectParams.size,
                                        total: _vm.mediaSelectParams.total,
                                        "page-sizes": [10, 20, 30, 40, 50, 100],
                                      },
                                      on: {
                                        "size-change":
                                          _vm.handleMediaSelectSizeChange,
                                        "current-change":
                                          _vm.handleMediaSelectCurrentChange,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-collapse-item",
                    { attrs: { name: "3" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c("h3", { staticClass: "add-title" }, [
                          _vm._v("续播频控配置"),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "add-item" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                "label-width": "150px",
                                prop: "dayLimit",
                                label: "媒资单日有效播放：",
                              },
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "15vw" },
                                attrs: { placeholder: "输入正整数" },
                                model: {
                                  value: _vm.addForm.dayLimit,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.addForm, "dayLimit", $$v)
                                  },
                                  expression: "addForm.dayLimit",
                                },
                              }),
                              _c("span", { staticClass: "tips" }, [
                                _vm._v("  次/设备"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-top": "15px" },
                              attrs: {
                                prop: "totalLimit",
                                "label-width": "150px",
                                label: "媒资总有效播放：",
                              },
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "15vw" },
                                attrs: { placeholder: "输入正整数" },
                                model: {
                                  value: _vm.addForm.totalLimit,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.addForm, "totalLimit", $$v)
                                  },
                                  expression: "addForm.totalLimit",
                                },
                              }),
                              _c("span", { staticClass: "tips2" }, [
                                _vm._v("  次/设备"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-collapse-item",
                    { attrs: { name: "4" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c("h3", { staticClass: "add-title" }, [
                          _vm._v("展示配置"),
                        ]),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "add-item",
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "imgType", label: "图片样式：" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.addForm.imgType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.addForm, "imgType", $$v)
                                    },
                                    expression: "addForm.imgType",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("横图样式"),
                                  ]),
                                  _c("el-radio", { attrs: { label: 2 } }, [
                                    _vm._v("竖图样式"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "isIntervene",
                                label: "排序人工干预：",
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.addForm.isIntervene,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.addForm, "isIntervene", $$v)
                                    },
                                    expression: "addForm.isIntervene",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("是"),
                                  ]),
                                  _c("el-radio", { attrs: { label: 0 } }, [
                                    _vm._v("否"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.addForm.isIntervene === 1
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "interveneQuantity",
                                    label: "干预数量：",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "输入正整数" },
                                    model: {
                                      value: _vm.addForm.interveneQuantity,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.addForm,
                                          "interveneQuantity",
                                          $$v
                                        )
                                      },
                                      expression: "addForm.interveneQuantity",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.addForm.isIntervene === 1
                            ? _c("el-form-item", { attrs: { label: " " } }, [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "gray",
                                      "font-size": "12px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "干预数量X，代表1~X\n                人工排序生效，X之后列表随机排序，0代表全随机"
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { padding: "1% 0 5% 5%" },
                  attrs: {
                    "label-width": "130px",
                    prop: "status",
                    label: "策略状态：",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.addForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.addForm, "status", $$v)
                        },
                        expression: "addForm.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("禁用")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirmSave } },
                [_vm._v("保 存")]
              ),
              _c("el-button", { on: { click: _vm.closeAddDialog } }, [
                _vm._v("取 消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "媒资选择",
            "append-to-body": "",
            visible: _vm.mediaSelectVisible,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.mediaSelectVisible = $event
            },
            closed: _vm.closeSelectDialog,
          },
        },
        [
          _c("div", { staticClass: "search-contain" }, [
            _c(
              "div",
              { staticClass: "search-left" },
              [
                _c("el-input", {
                  staticStyle: { width: "70%" },
                  attrs: {
                    clearable: "",
                    placeholder: "乐播媒资ID/三方媒资ID/媒资名称",
                  },
                  model: {
                    value: _vm.mediaSearchParams.search,
                    callback: function ($$v) {
                      _vm.$set(_vm.mediaSearchParams, "search", $$v)
                    },
                    expression: "mediaSearchParams.search",
                  },
                }),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "40%", "margin-left": "20px" },
                    attrs: { clearable: "", placeholder: "媒资类型" },
                    model: {
                      value: _vm.mediaSearchParams.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.mediaSearchParams, "type", $$v)
                      },
                      expression: "mediaSearchParams.type",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "电影", value: "1" } }),
                    _c("el-option", { attrs: { label: "电视剧", value: "2" } }),
                    _c("el-option", { attrs: { label: "动画片", value: "3" } }),
                    _c("el-option", { attrs: { label: "短剧", value: "4" } }),
                    _c("el-option", { attrs: { label: "电影票", value: "5" } }),
                    _c("el-option", { attrs: { label: "团购券", value: "6" } }),
                    _c("el-option", { attrs: { label: "其它", value: "0" } }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "search-right" },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "10px" },
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.mediaSearch },
                  },
                  [_vm._v("搜索")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              ref: "mediaTable",
              staticStyle: { "margin-top": "20px" },
              attrs: {
                "row-key": "id",
                data: _vm.mediaTable,
                border: "",
                stripe: "",
              },
              on: {
                select: _vm.handleSelectionChange,
                "select-all": _vm.selectAll,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { prop: "renderMediaId", label: "乐播媒资ID" },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "name",
                  label: "媒资名称",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticStyle: { color: "blue" } }, [
                          _vm._v(_vm._s(scope.row.name)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "mediaType", label: "媒资类型" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.row.type === 0
                                ? "其他"
                                : scope.row.type === 1
                                ? "电影"
                                : scope.row.type === 2
                                ? "电视剧"
                                : scope.row.type === 3
                                ? "动画片"
                                : scope.row.type === 4
                                ? "短剧"
                                : scope.row.type === 5
                                ? "电影票"
                                : scope.row.type === 6
                                ? "团购券"
                                : ""
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "horizontalImg", label: "横图" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.horizontalImgLarge
                          ? _c("el-image", {
                              attrs: {
                                src: scope.row.horizontalImgLarge,
                                previewSrcList: [scope.row.horizontalImgLarge],
                                alt: "",
                              },
                            })
                          : scope.row.horizontalImgSmall
                          ? _c("el-image", {
                              attrs: {
                                src: scope.row.horizontalImgSmall,
                                previewSrcList: [scope.row.horizontalImgSmall],
                                alt: "",
                              },
                            })
                          : _c("span", [_vm._v("暂无图片")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "status", label: "媒资状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          { class: { "green-text": scope.row.status === 1 } },
                          [
                            _vm._v(
                              _vm._s(scope.row.status === 1 ? "上线" : "下线")
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { width: "180", prop: "updateTime", label: "更新时间" },
              }),
            ],
            1
          ),
          _c("ElementPagination", {
            staticStyle: { "margin-bottom": "20px" },
            attrs: {
              "current-page": _vm.mediaSearchParams.current,
              "page-size": _vm.mediaSearchParams.size,
              total: _vm.mediaSearchParams.total,
              "page-sizes": [10, 20, 30, 40, 50],
            },
            on: {
              "size-change": _vm.mediaSizeChange,
              "current-change": _vm.mediaCurrentChange,
            },
          }),
          _c(
            "el-popover",
            {
              attrs: {
                placement: "top",
                title: "",
                width: "400",
                trigger: "click",
              },
            },
            [
              _c("div", [_vm._v("已选记录列表")]),
              _c("div", [
                _vm._v(
                  "\n        已选择 (" + _vm._s(_vm.selectNum) + ")\n        "
                ),
                _c(
                  "span",
                  {
                    staticStyle: { cursor: "pointer", color: "#3370ff" },
                    on: {
                      click: function ($event) {
                        return _vm.selectedDel("")
                      },
                    },
                  },
                  [_vm._v("全部移除")]
                ),
              ]),
              _c(
                "el-table",
                { attrs: { "max-height": "500", data: _vm.selectList } },
                [
                  _c("el-table-column", {
                    attrs: {
                      width: "150",
                      prop: "renderMediaId",
                      label: "乐播媒资ID",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { width: "100", prop: "name", label: "媒资名称" },
                  }),
                  _c("el-table-column", {
                    attrs: { width: "100", label: "操作" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectedDel(scope.row)
                                  },
                                },
                              },
                              [_vm._v("移出")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { width: "80px", cursor: "pointer" },
                  attrs: { slot: "reference" },
                  slot: "reference",
                },
                [
                  _c("span", [
                    _vm._v("已选择  "),
                    _c(
                      "span",
                      { staticStyle: { color: "#3370ff", cursor: "pointer" } },
                      [_vm._v("(" + _vm._s(_vm.selectNum) + ")")]
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.mediaIdSelectOk },
                },
                [_vm._v("确 定")]
              ),
              _c("el-button", { on: { click: _vm.closeSelectDialog } }, [
                _vm._v("取 消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.mediaEditDialog,
            title: "媒资编辑",
            "append-to-body": "",
            "modal-append-to-body": false,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.mediaEditDialog = $event
            },
            closed: _vm.mediaEditClose,
          },
        },
        [
          _c(
            "div",
            {},
            [
              _c(
                "el-form",
                {
                  ref: "mediaEditForm",
                  staticStyle: { "margin-left": "20px" },
                  attrs: {
                    model: _vm.mediaEditData,
                    rules: _vm.mediaEditFormRules,
                    inline: "",
                    "label-position": "left",
                    "label-width": "130px",
                  },
                },
                [
                  _c("div", { staticStyle: { display: "flex" } }, [
                    _c(
                      "div",
                      { staticStyle: { flex: "1" } },
                      [
                        _c("el-form-item", { attrs: { label: "媒资名称：" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.mediaEditData.media.name) +
                              "\n            "
                          ),
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { label: "横图：" } },
                          [
                            _vm.mediaEditData.media.horizontalImg
                              ? _c("el-image", {
                                  staticStyle: {
                                    width: "150px",
                                    height: "100px",
                                  },
                                  attrs: {
                                    src: _vm.mediaEditData.media.horizontalImg,
                                    "preview-src-list": [
                                      _vm.mediaEditData.media.horizontalImg,
                                    ],
                                    alt: "",
                                  },
                                })
                              : _c("span", [_vm._v("暂无图片")]),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "展示选择：" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.mediaEditData.useType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.mediaEditData, "useType", $$v)
                                  },
                                  expression: "mediaEditData.useType",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 2 } }, [
                                  _vm._v("分集"),
                                ]),
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v("片花"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          flex: "1",
                          display: "flex",
                          "flex-direction": "column",
                        },
                      },
                      [
                        _c("el-form-item", { attrs: { label: "媒资类型：" } }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.mediaEditData.media.type === 0
                                  ? "其他"
                                  : _vm.mediaEditData.media.type === 1
                                  ? "电影"
                                  : _vm.mediaEditData.media.type === 2
                                  ? "电视剧"
                                  : _vm.mediaEditData.media.type === 3
                                  ? "动画片"
                                  : _vm.mediaEditData.media.type === 4
                                  ? "短剧"
                                  : _vm.mediaEditData.media.type === 5
                                  ? "电影票"
                                  : _vm.mediaEditData.media.type === 6
                                  ? "团购券"
                                  : ""
                              )
                            ),
                          ]),
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { label: "竖图：" } },
                          [
                            _vm.mediaEditData.media.verticalImg
                              ? _c("el-image", {
                                  staticStyle: {
                                    width: "100px",
                                    height: "100px",
                                  },
                                  attrs: {
                                    src: _vm.mediaEditData.media.verticalImg,
                                    "preview-src-list": [
                                      _vm.mediaEditData.media.verticalImg,
                                    ],
                                    alt: "",
                                  },
                                })
                              : _c("span", [_vm._v("暂无图片")]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                      },
                    },
                    [
                      _vm.mediaEditData.useType === 1
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "片花选择：" } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { width: "100px" },
                                  attrs: { size: "small" },
                                  on: { click: _vm.handleTrailerSelect },
                                },
                                [_vm._v("选择")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("el-form-item", { attrs: { label: " " } }, [
                        _vm.mediaEditData.useType === 1 &&
                        _vm.mediaEditData.trailer.id
                          ? _c("span", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.mediaEditData.trailer.name +
                                      `(${_vm.mediaEditData.trailer.id})`
                                  )
                              ),
                            ])
                          : _vm._e(),
                        _vm.mediaEditData.useType === 1 &&
                        _vm.mediaEditData.trailer.id
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#3370ff",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleMediaEditPreview(
                                      _vm.mediaEditData
                                    )
                                  },
                                },
                              },
                              [_vm._v("   预览")]
                            )
                          : _vm._e(),
                      ]),
                      _vm.mediaEditData.useType === 2
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "分集选择：" } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { width: "100px" },
                                  attrs: { size: "small" },
                                  on: { click: _vm.handleDiversitySelect },
                                },
                                [_vm._v("选择")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("el-form-item", { attrs: { label: " " } }, [
                        _vm.mediaEditData.useType === 2 &&
                        _vm.mediaEditData.episode.id
                          ? _c("span", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.mediaEditData.episode.name +
                                      `(${_vm.mediaEditData.episode.id})`
                                  )
                              ),
                            ])
                          : _vm._e(),
                        _vm.mediaEditData.useType === 2 &&
                        _vm.mediaEditData.episode.id
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#3370ff",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleMediaEditPreview(
                                      _vm.mediaEditData
                                    )
                                  },
                                },
                              },
                              [_vm._v("   预览")]
                            )
                          : _vm._e(),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "生效时间：" } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.mediaEditData.timeWay,
                                callback: function ($$v) {
                                  _vm.$set(_vm.mediaEditData, "timeWay", $$v)
                                },
                                expression: "mediaEditData.timeWay",
                              },
                            },
                            [
                              _c("el-checkbox", { attrs: { label: "1" } }, [
                                _vm._v("总时段生效"),
                              ]),
                              _c("el-checkbox", { attrs: { label: "2" } }, [
                                _vm._v("单日时段生效"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.mediaEditData.timeWay.includes("1")
                        ? _c("el-form-item", { attrs: { label: "总时段：" } }, [
                            _c("div", { staticStyle: { display: "flex" } }, [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    ref: "startDatePicker",
                                    attrs: {
                                      type: "date",
                                      placeholder: "选择日期",
                                    },
                                    model: {
                                      value: _vm.mediaEditData.validStartDate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.mediaEditData,
                                          "validStartDate",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "mediaEditData.validStartDate",
                                    },
                                  }),
                                  _c("span", [_vm._v("开始时间")]),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column",
                                    "align-items": "center",
                                    "margin-left": "10px",
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    ref: "endDatePicker",
                                    attrs: {
                                      "picker-options": _vm.endPickerOptions,
                                      type: "date",
                                      placeholder: "选择日期",
                                    },
                                    model: {
                                      value: _vm.mediaEditData.validEndDate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.mediaEditData,
                                          "validEndDate",
                                          $$v
                                        )
                                      },
                                      expression: "mediaEditData.validEndDate",
                                    },
                                  }),
                                  _c("span", [_vm._v("结束时间")]),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.mediaEditData.timeWay.includes("2")
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "单日时段：" } },
                            [
                              _c("div", { staticStyle: { display: "flex" } }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "flex-direction": "column",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c("el-time-picker", {
                                      attrs: {
                                        format: "HH:mm:ss",
                                        placeholder: "选择日期",
                                      },
                                      model: {
                                        value: _vm.mediaEditData.validStartTime,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.mediaEditData,
                                            "validStartTime",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "mediaEditData.validStartTime",
                                      },
                                    }),
                                    _c("span", [_vm._v("开始时间")]),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "flex-direction": "column",
                                      "align-items": "center",
                                      "margin-left": "10px",
                                    },
                                  },
                                  [
                                    _c("el-time-picker", {
                                      attrs: {
                                        format: "HH:mm:ss",
                                        "picker-options":
                                          _vm.endSinglePickerOptions,
                                        placeholder: "选择日期",
                                      },
                                      model: {
                                        value: _vm.mediaEditData.validEndTime,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.mediaEditData,
                                            "validEndTime",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "mediaEditData.validEndTime",
                                      },
                                    }),
                                    _c("span", [_vm._v("结束时间")]),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "justify-content": "end",
                  },
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.confirmMediaEdit },
                    },
                    [_vm._v("保 存")]
                  ),
                  _c("el-button", { on: { click: _vm.mediaEditClose } }, [
                    _vm._v("取 消"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.partnerDiversityDialog,
            title: "三方分集信息",
            "append-to-body": "",
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.partnerDiversityDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.partnerDiversityData,
                "label-position": "left",
                "label-width": "130px",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    padding: "0 40px",
                    display: "flex",
                    "flex-direction": "row",
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { flex: "1" } },
                    [
                      _c("el-form-item", { attrs: { label: "三方分集ID：" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.diversityDetailData.episodePartnerData.id
                                ? _vm.diversityDetailData.episodePartnerData.id
                                : "-"
                            ) +
                            "\n          "
                        ),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "版权商分集ID ：" } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.diversityDetailData.episodePartnerData
                                  .copyrightEpisodeId
                                  ? _vm.diversityDetailData.episodePartnerData
                                      .copyrightEpisodeId
                                  : "-"
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { flex: "1" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "三方分集状态：" } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.diversityDetailData.episodePartnerData
                                  .partnerEpisodeStatus === 1
                                  ? "已上架"
                                  : "已下架"
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "版权商分集编号：" } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.diversityDetailData.episodePartnerData
                                  .copyrightEpisodeCode
                                  ? _vm.diversityDetailData.episodePartnerData
                                      .copyrightEpisodeCode
                                  : "-"
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.partnerTrailerDialog,
            title: "三方片花信息",
            "append-to-body": "",
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.partnerTrailerDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.partnerTrailerData,
                "label-position": "left",
                "label-width": "130px",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    padding: "0 40px",
                    display: "flex",
                    "flex-direction": "row",
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { flex: "1" } },
                    [
                      _c("el-form-item", { attrs: { label: "三方片花ID：" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.trailerDetailData.trailerPartnerData
                                .partnerTrailerId
                                ? _vm.trailerDetailData.trailerPartnerData
                                    .partnerTrailerId
                                : "-"
                            ) +
                            "\n          "
                        ),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "版权商片花ID ：" } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.trailerDetailData.trailerPartnerData
                                  .copyrightTrailerId
                                  ? _vm.trailerDetailData.trailerPartnerData
                                      .copyrightTrailerId
                                  : "-"
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { flex: "1" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "三方片花状态：" } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.trailerDetailData.trailerPartnerData
                                  .partnerTrailerStatus === 1
                                  ? "已上架"
                                  : "已下架"
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "版权商片花编号：" } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.trailerDetailData.trailerPartnerData
                                  .copyrightTrailerCode
                                  ? _vm.trailerDetailData.trailerPartnerData
                                      .copyrightTrailerCode
                                  : "-"
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.trailerSelectDialog,
            title: "片花选择",
            "append-to-body": "",
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.trailerSelectDialog = $event
            },
            closed: _vm.trailerSelectCancel,
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("el-input", {
                    staticStyle: { "margin-right": "10px", width: "150px" },
                    attrs: {
                      size: "small",
                      placeholder: "片花ID",
                      clearable: "",
                    },
                    model: {
                      value: _vm.trailerId,
                      callback: function ($$v) {
                        _vm.trailerId = $$v
                      },
                      expression: "trailerId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.trailerSearch },
                    },
                    [_vm._v("搜索")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-table",
            {
              staticStyle: { "margin-top": "20px" },
              attrs: { data: _vm.trailerTable, border: "", stripe: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: scope.row.id },
                            on: {
                              change: function ($event) {
                                return _vm.handleTrailerRadioChange(scope.row)
                              },
                            },
                            model: {
                              value: _vm.trailerRadioId,
                              callback: function ($$v) {
                                _vm.trailerRadioId = $$v
                              },
                              expression: "trailerRadioId",
                            },
                          },
                          [_vm._v(_vm._s(_vm.trailerSpace))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", { attrs: { prop: "id", label: "片花ID" } }),
              _c("el-table-column", {
                attrs: { prop: "mediaName", label: "对应分集" },
              }),
              _c("el-table-column", {
                attrs: { prop: "type", label: "类型" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.type === 0
                          ? _c("span", [_vm._v("其它")])
                          : scope.row.type === 1
                          ? _c("span", [_vm._v("片花/花絮")])
                          : scope.row.type === 2
                          ? _c("span", [_vm._v("预告片")])
                          : scope.row.type === 3
                          ? _c("span", [_vm._v("高能看点")])
                          : scope.row.type === 4
                          ? _c("span", [_vm._v("二次创作")])
                          : scope.row.type === 5
                          ? _c("span", [_vm._v("一般关系")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "name", label: "封面" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.horizontalImg
                          ? _c("el-image", {
                              attrs: {
                                src: scope.row.horizontalImg,
                                previewSrcList: [scope.row.horizontalImg],
                                alt: "",
                              },
                            })
                          : _c("span", [_vm._v("暂无图片")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "duration", label: "时长" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("secondsToStandardization")(
                                scope.row.duration,
                                scope.row.duration
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(scope.row.status === 1 ? "上线" : "下线")
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "updateTime", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleTrailerPreview(scope.row)
                              },
                            },
                          },
                          [_vm._v("预览")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleTrailerDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.trailerSelectOk },
                },
                [_vm._v("确 定")]
              ),
              _c("el-button", { on: { click: _vm.trailerSelectCancel } }, [
                _vm._v("取 消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.diversitySelectDialog,
            title: "分集选择",
            "append-to-body": "",
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.diversitySelectDialog = $event
            },
            closed: _vm.diversitySelectCancel,
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("el-input", {
                    staticStyle: { "margin-right": "10px", width: "150px" },
                    attrs: {
                      size: "small",
                      placeholder: "分集ID",
                      clearable: "",
                    },
                    model: {
                      value: _vm.diversityId,
                      callback: function ($$v) {
                        _vm.diversityId = $$v
                      },
                      expression: "diversityId",
                    },
                  }),
                  _c("el-input", {
                    staticStyle: { width: "150px" },
                    attrs: {
                      size: "small",
                      placeholder: "分集名称",
                      clearable: "",
                    },
                    model: {
                      value: _vm.diversityName,
                      callback: function ($$v) {
                        _vm.diversityName = $$v
                      },
                      expression: "diversityName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.diversitySearch },
                    },
                    [_vm._v("搜索")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-table",
            {
              staticStyle: { "margin-top": "20px" },
              attrs: { data: _vm.diversityTable, border: "", stripe: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: scope.row.id },
                            on: {
                              change: function ($event) {
                                return _vm.handleDiversityRadioChange(scope.row)
                              },
                            },
                            model: {
                              value: _vm.diversityRadioId,
                              callback: function ($$v) {
                                _vm.diversityRadioId = $$v
                              },
                              expression: "diversityRadioId",
                            },
                          },
                          [_vm._v(_vm._s(_vm.diversitySpace))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", { attrs: { prop: "id", label: "分集ID" } }),
              _c("el-table-column", {
                attrs: { prop: "num", label: "分集序号" },
              }),
              _c("el-table-column", {
                attrs: { prop: "name", label: "分集名称" },
              }),
              _c("el-table-column", {
                attrs: { prop: "feeMode", label: "解锁" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.row.episodeMovie.feeMode === 0
                                ? "是"
                                : scope.row.episodeMovie.feeMode === 2
                                ? "否"
                                : ""
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "horizontalImg", label: "封面" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.horizontalImg
                          ? _c("el-image", {
                              attrs: {
                                src: scope.row.horizontalImg,
                                previewSrcList: [scope.row.horizontalImg],
                                alt: "",
                              },
                            })
                          : _c("span", [_vm._v("暂无图片")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "updateTime", label: "状态" },
              }),
              _c("el-table-column", {
                attrs: { prop: "updateTime", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDiversityPreview(scope.row)
                              },
                            },
                          },
                          [_vm._v("预览")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDiversityDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.diversitySelectOk },
                },
                [_vm._v("确 定")]
              ),
              _c("el-button", { on: { click: _vm.diversitySelectCancel } }, [
                _vm._v("取 消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.diversityDetailDialog,
            title: "分集详情",
            "append-to-body": "",
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.diversityDetailDialog = $event
            },
            closed: _vm.diversityCloseCancel,
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.diversityDetailData,
                "label-position": "left",
                "label-width": "130px",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    padding: "0 40px",
                    display: "flex",
                    "flex-direction": "row",
                    "background-color": "#f7f7f7",
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { flex: "1" } },
                    [
                      _c("el-form-item", { attrs: { label: "乐播分集ID：" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.diversityDetailData.id) +
                            "\n          "
                        ),
                      ]),
                      _c("el-form-item", { attrs: { label: "分集名称：" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.diversityDetailData.name
                                ? _vm.diversityDetailData.name
                                : "-"
                            ) +
                            "\n          "
                        ),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "横图：" } },
                        [
                          _vm.diversityDetailData.horizontalImg
                            ? _c("el-image", {
                                staticStyle: {
                                  width: "150px",
                                  height: "100px",
                                },
                                attrs: {
                                  src: _vm.diversityDetailData.horizontalImg,
                                  "preview-src-list": [
                                    _vm.diversityDetailData.horizontalImg,
                                  ],
                                  alt: "",
                                },
                              })
                            : _c("span", [_vm._v("暂无图片")]),
                        ],
                        1
                      ),
                      _c("el-form-item", { attrs: { label: "时长：" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm._f("secondsToStandardization")(
                                _vm.diversityDetailData.duration,
                                _vm.diversityDetailData.duration
                              )
                            ) +
                            "\n          "
                        ),
                      ]),
                      _c("el-form-item", { attrs: { label: "是否付费：" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.diversityDetailData.feeMode === 0
                                ? "否"
                                : "是"
                            ) +
                            "\n          "
                        ),
                      ]),
                      _c("el-form-item", { attrs: { label: "播放链接" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.diversityDetailData.playUrl)
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#15a2f2",
                              cursor: "pointer",
                            },
                            on: {
                              click: () => {
                                _vm.videoUrl = _vm.diversityDetailData.playUrl
                                _vm.videoDialogVisible = true
                              },
                            },
                          },
                          [_vm._v("  预览")]
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { flex: "1" } },
                    [
                      _c("el-form-item", { attrs: { label: "分集序号：" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.diversityDetailData.num
                                ? _vm.diversityDetailData.num
                                : "-"
                            ) +
                            "\n          "
                        ),
                      ]),
                      _c("el-form-item", { attrs: { label: "分集描述：" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.diversityDetailData.aword
                                ? _vm.diversityDetailData.aword
                                : "-"
                            ) +
                            "\n          "
                        ),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "竖图：" } },
                        [
                          _vm.diversityDetailData.verticalImg
                            ? _c("el-image", {
                                staticStyle: {
                                  width: "100px",
                                  height: "100px",
                                },
                                attrs: {
                                  src: _vm.diversityDetailData.verticalImg,
                                  "preview-src-list": [
                                    _vm.diversityDetailData.verticalImg,
                                  ],
                                  alt: "",
                                },
                              })
                            : _c("span", [_vm._v("暂无图片")]),
                        ],
                        1
                      ),
                      _c("el-form-item", { attrs: { label: "试看时长：" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm._f("secondsToStandardization")(
                                _vm.diversityDetailData.episodeMovie
                                  .trialDuration,
                                _vm.diversityDetailData.episodeMovie
                                  .trialDuration
                              )
                            ) +
                            "\n          "
                        ),
                      ]),
                      _c("el-form-item", { attrs: { label: "视频样式：" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.diversityDetailData.direction === 1
                                ? "横视频"
                                : _vm.diversityDetailData.direction === 2
                                ? "竖视频"
                                : "-"
                            ) +
                            "\n          "
                        ),
                      ]),
                      _c("el-form-item", { attrs: { label: "二维码地址：" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.diversityDetailData.qrCode
                                ? _vm.diversityDetailData.qrCode
                                : "-"
                            ) +
                            "\n          "
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    padding: "0 40px",
                    display: "flex",
                    "justify-content": "space-between",
                  },
                },
                [
                  _c("el-form-item", { attrs: { label: "分集状态：" } }, [
                    _c(
                      "span",
                      {
                        class: {
                          "green-text": _vm.diversityDetailData.status === 1,
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.diversityDetailData.status === 0
                              ? "下线"
                              : "上线"
                          )
                        ),
                      ]
                    ),
                  ]),
                  _c("el-form-item", { attrs: { label: " " } }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "text-decoration": "underline",
                          color: "#15a2f2",
                          cursor: "pointer",
                        },
                        on: { click: _vm.handlePartnerDiversity },
                      },
                      [_vm._v("三方分集信息")]
                    ),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.trailerDetailDialog,
            title: "片花详情",
            "append-to-body": "",
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.trailerDetailDialog = $event
            },
            closed: _vm.trailerCloseCancel,
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.trailerDetailData,
                "label-position": "left",
                "label-width": "130px",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    padding: "0 40px",
                    display: "flex",
                    "flex-direction": "row",
                    "background-color": "#f7f7f7",
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { flex: "1" } },
                    [
                      _c("el-form-item", { attrs: { label: "乐播片花ID：" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.trailerDetailData.id
                                ? _vm.trailerDetailData.id
                                : "-"
                            ) +
                            "\n          "
                        ),
                      ]),
                      _c("el-form-item", { attrs: { label: "片花名称：" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.trailerDetailData.aword
                                ? _vm.trailerDetailData.aword
                                : "-"
                            ) +
                            "\n          "
                        ),
                      ]),
                      _c("el-form-item", { attrs: { label: "对应分集：" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.trailerDetailData.episodeName
                                ? _vm.trailerDetailData.episodeName
                                : "-"
                            ) +
                            "\n          "
                        ),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "横图：" } },
                        [
                          _vm.trailerDetailData.horizontalImg
                            ? _c("el-image", {
                                staticStyle: {
                                  width: "150px",
                                  height: "100px",
                                },
                                attrs: {
                                  src: _vm.trailerDetailData.horizontalImg,
                                  "preview-src-list": [
                                    _vm.trailerDetailData.horizontalImg,
                                  ],
                                  alt: "",
                                },
                              })
                            : _c("span", [_vm._v("暂无图片")]),
                        ],
                        1
                      ),
                      _c("el-form-item", { attrs: { label: "视频样式：" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.trailerDetailData.direction === 1
                                ? "横视频"
                                : _vm.trailerDetailData.direction === 2
                                ? "竖视频"
                                : "-"
                            ) +
                            "\n          "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { flex: "1" } },
                    [
                      _c("el-form-item", { attrs: { label: "对应剧片：" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.trailerDetailData.mediaName
                                ? _vm.trailerDetailData.mediaName
                                : "-"
                            ) +
                            "\n          "
                        ),
                      ]),
                      _c("el-form-item", { attrs: { label: "类型：" } }, [
                        _vm.trailerDetailData.type === 0
                          ? _c("span", [_vm._v("其它")])
                          : _vm.trailerDetailData.type === 1
                          ? _c("span", [_vm._v("片花/花絮")])
                          : _vm.trailerDetailData.type === 2
                          ? _c("span", [_vm._v("预告片")])
                          : _vm.trailerDetailData.type === 3
                          ? _c("span", [_vm._v("高能看点")])
                          : _vm.trailerDetailData.type === 4
                          ? _c("span", [_vm._v("二次创作")])
                          : _vm.trailerDetailData.type === 5
                          ? _c("span", [_vm._v("一般关系")])
                          : _vm._e(),
                      ]),
                      _c("el-form-item", { attrs: { label: "时长：" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm._f("secondsToStandardization")(
                                _vm.trailerDetailData.duration,
                                _vm.trailerDetailData.duration
                              )
                            ) +
                            "\n          "
                        ),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "竖图：" } },
                        [
                          _vm.trailerDetailData.verticalImg
                            ? _c("el-image", {
                                staticStyle: {
                                  width: "100px",
                                  height: "100px",
                                },
                                attrs: {
                                  src: _vm.trailerDetailData.verticalImg,
                                  "preview-src-list": [
                                    _vm.trailerDetailData.verticalImg,
                                  ],
                                  alt: "",
                                },
                              })
                            : _c("span", [_vm._v("暂无图片")]),
                        ],
                        1
                      ),
                      _c("el-form-item", { attrs: { label: "播放链接：" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.trailerDetailData.playUrl) +
                            "\n            "
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#15a2f2",
                              cursor: "pointer",
                            },
                            on: {
                              click: () => {
                                _vm.videoUrl = _vm.trailerDetailData.playUrl
                                _vm.videoDialogVisible = true
                              },
                            },
                          },
                          [_vm._v("  预览")]
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    padding: "0 40px",
                    display: "flex",
                    "justify-content": "space-between",
                  },
                },
                [
                  _c("el-form-item", { attrs: { label: "片花状态：" } }, [
                    _c(
                      "span",
                      {
                        class: {
                          "green-text": _vm.trailerDetailData.status === 1,
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.trailerDetailData.status === 1 ? "上线" : "下线"
                          )
                        ),
                      ]
                    ),
                  ]),
                  _c("el-form-item", { attrs: { label: " " } }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "text-decoration": "underline",
                          color: "#15a2f2",
                          cursor: "pointer",
                        },
                        on: { click: _vm.handlePartnerTrailer },
                      },
                      [_vm._v("三方片花信息")]
                    ),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("VideoDialog", {
        attrs: {
          videoDialogVisible: _vm.videoDialogVisible,
          videoUrl: _vm.videoUrl,
        },
        on: {
          "update:videoDialogVisible": function ($event) {
            _vm.videoDialogVisible = $event
          },
          "update:video-dialog-visible": function ($event) {
            _vm.videoDialogVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }